import { ethers } from "ethers";
import BridgeABI from "@razor-network/bridge-contracts-snapshot/abi/SelectionManager.json";
import SignerManagerABI from "@razor-network/bridge-contracts-snapshot/abi/SignerManager.json";
import StakeManagerABI from "@razor-network/bridge-contracts-snapshot/abi/StakeManager.json";
import DelegationManagerABI from "@razor-network/bridge-contracts-snapshot/abi/DelegationManager.json";
import StakedTokenABI from "@razor-network/bridge-contracts-snapshot/abi/WrappedMetalayerToken.json";
import MetalayerTokenABI from "@razor-network/bridge-contracts-snapshot/abi/MetalayerToken.json";
import WrappedMetalayerTokenABI from "@razor-network/bridge-contracts-snapshot/abi/WrappedMetalayerToken.json";
import addresses from "@razor-network/bridge-contracts-snapshot/deployments/info/testnet/native.json";
import { RPC_URL } from "./constants";
import moment from "moment";

export const provider = new ethers.providers.JsonRpcProvider(RPC_URL);
export const EPOCH_LENGTH = 120;
export const DYNASTY_LENGTH = 50;

const bridge = new ethers.Contract(
  addresses.SelectionManager,
  BridgeABI,
  provider
);
const signerManager = new ethers.Contract(
  addresses.SignerManager, // TODO: verify once after contracts are deployed
  SignerManagerABI,
  provider
)
const STAKE_MANAGER_ADDRESS = addresses.StakeManager;
const METALAYER_TOKEN_ADDRESS = addresses.MetalayerToken;
const DELEGATION_MANAGER_ADDRESS = addresses.DelegationManager;
export const WRAPPED_MTLR_TOKEN_ADDRESS = addresses.WrappedMetalayerToken;
export const ZERO_ADDRESS = "0x0000000000000000000000000000000000000000";

export const getMode = async () => {
  try {
    const mode = await bridge.getMode();
    return mode;
  } catch (error) {
    console.log("error occured while fetching mode:", error);
  }
};

export const getEpoch = async () => {
  try {
    const [,epoch] = await bridge.getDynastyAndEpoch();
    return epoch;
  } catch (error) {
    console.log("error occured while fetching epoch:", error);
  }
};

export const getDynasty = async () => {
  try {
    const dynasty = await bridge.getDynasty();
    return dynasty;
  } catch (error) {
    console.log("error occured while fetching dynasty:", error);
  }
};

export const getSignerAddressPerDynasty = async (dynasty) => {
  try {
    const signerAddress = await signerManager.signerAddressPerDynasty(dynasty);
    return signerAddress;
  } catch (error) {
    console.log("error occured while fetching signer address:", error);
  }
};

export const getLatestBlockTimestamp = async () => {
  try {
    const block = await provider.getBlock("latest");
    console.log({ block });
    return block.timestamp;
  } catch (error) {
    console.log("error occured while fetching block timestamp:", error);
  }
};

export const approveToken = async (amount) => {
  try {
    amount = ethers.utils.parseEther(amount.toString());
    const provider = new ethers.providers.Web3Provider(window.ethereum);

    const signer = provider.getSigner();
    const tokenContract = new ethers.Contract(
      WRAPPED_MTLR_TOKEN_ADDRESS,
      WrappedMetalayerTokenABI,
      signer
    );
    const approveTx = await tokenContract.approve(
      DELEGATION_MANAGER_ADDRESS,
      amount
    );
    if (!approveTx) {
      return {
        success: false,
        txHash: null,
        error: null,
      };
    }

    await approveTx.wait();
    return {
      success: true,
      txHash: approveTx.hash,
      error: null,
    };
  } catch (error) {
    console.log("error occured while approving tokens", error);
    return {
      success: false,
      txHash: null,
      error,
    };
  }
};

// * Delegator
export const delegate = async (operatorId, amount) => {
  try {
    amount = ethers.utils.parseEther(amount.toString());
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    // const provider = new ethers.providers.JsonRpcProvider(
    //     "https://staging-v3.skalenodes.com/v1/staging-aware-chief-gianfar"
    //   );
    const signer = provider.getSigner();
    const delegationManagerContract = new ethers.Contract(
      DELEGATION_MANAGER_ADDRESS,
      DelegationManagerABI,
      signer
    );
    console.log(delegationManagerContract?.address, amount, operatorId);
    const delegateTx = await delegationManagerContract.delegate(
      parseInt(operatorId),
      amount
    );
    console.log(delegateTx);
    if (!delegateTx) {
      return {
        success: false,
        txHash: null,
        error: null,
      };
    }

    await delegateTx.wait();
    return {
      success: true,
      txHash: delegateTx.hash,
      error: null,
    };
  } catch (error) {
    console.log("Error occured while delegating tokens", error);
    return {
      success: false,
      txHash: null,
      error,
    };
  }
};

export const approveDToken = async (amount, dTokenAddress) => {
  try {
    amount = ethers.utils.parseEther(amount.toString());
    const provider = new ethers.providers.Web3Provider(window.ethereum);

    const signer = provider.getSigner();
    const tokenContract = new ethers.Contract(
      dTokenAddress,
      StakedTokenABI,
      signer
    );

    const approveTx = await tokenContract.approve(
      DELEGATION_MANAGER_ADDRESS,
      amount
    );
    if (!approveTx) {
      return {
        success: false,
        txHash: null,
        error: null,
      };
    }

    await approveTx.wait();
    return {
      success: true,
      txHash: approveTx.hash,
      error: null,
    };
  } catch (error) {
    console.log("error occured while approving tokens", error);
    return {
      success: false,
      txHash: null,
      error,
    };
  }
};


// * Delegator
export const signalWithdraw = async (operatorId, dAmount) => {
  try {
    dAmount = ethers.utils.parseEther(dAmount.toString());
    console.log(dAmount);
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const delegationManagerContract = new ethers.Contract(
      DELEGATION_MANAGER_ADDRESS,
      DelegationManagerABI,
      signer
    );

    const signalWithdrawTx = await delegationManagerContract.signalWithdraw(
      operatorId,
      dAmount
    );
    if (!signalWithdrawTx) {
      return {
        success: false,
        txHash: null,
        error: null,
      };
    }

    await signalWithdrawTx.wait();
    return {
      success: true,
      txHash: signalWithdrawTx.hash,
      error: null,
    };
  } catch (error) {
    console.log("Error occured while signal withdrawing tokens", error);
    return {
      success: false,
      txHash: null,
      error,
    };
  }
};

// * Delegator
export const initiateWithdraw = async (operatorId) => {
  try {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const delegationManagerContract = new ethers.Contract(
      DELEGATION_MANAGER_ADDRESS,
      DelegationManagerABI,
      signer
    );

    const initiateWithdrawTx = await delegationManagerContract.initiateWithdraw(
      operatorId
    );
    if (!initiateWithdrawTx) {
      return {
        success: false,
        txHash: null,
        error: null,
      };
    }

    await initiateWithdrawTx.wait();
    return {
      success: true,
      txHash: initiateWithdrawTx.hash,
      error: null,
    };
  } catch (error) {
    console.log("Error occured while initiating withdraw tokens", error);
    return {
      success: false,
      txHash: null,
      error,
    };
  }
};

// * Delegator
export const executeWithdraw = async (operatorId) => {
  try {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const delegationManagerContract = new ethers.Contract(
      DELEGATION_MANAGER_ADDRESS,
      DelegationManagerABI,
      signer
    );

    const withdrawTx = await delegationManagerContract.executeWithdraw(operatorId);
    if (!withdrawTx) {
      return {
        success: false,
        txHash: null,
        error: null,
      };
    }

    await withdrawTx.wait();
    return {
      success: true,
      txHash: withdrawTx.hash,
      error: null,
    };
  } catch (error) {
    console.log("Error occured while executing withdraw tokens", error);
    return {
      success: false,
      txHash: null,
      error,
    };
  }
};

// * Delegator
export const resetSignalLock = async (operatorId) => {
  try {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const delegationManagerContract = new ethers.Contract(
      DELEGATION_MANAGER_ADDRESS,
      DelegationManagerABI,
      signer
    );

    const resetSignalLockTx = await delegationManagerContract.resetSignalLock(
      operatorId
    );
    if (!resetSignalLockTx) {
      return {
        success: false,
        txHash: null,
        error: null,
      };
    }
    await resetSignalLockTx.wait();
    return {
      success: true,
      txHash: resetSignalLockTx.hash,
      error: null,
    };
  } catch (error) {
    console.log("error occured while resetting signal lock", error);
    return {
      success: false,
      txHash: null,
      error,
    };
  }
};

export const getdTokenBalance = async (tokenAddress, address) => {
  if (address) {
    try {
      const provider = new ethers.providers.JsonRpcProvider(RPC_URL);
      const sRazorContract = new ethers.Contract(
        tokenAddress,
        MetalayerTokenABI,
        provider
      );
      const balance = await sRazorContract.balanceOf(address);
      const balanceInEther = ethers.utils.formatEther(balance);
      return balanceInEther;
    } catch (error) {
      console.log("error while fetching razor balance");
      console.log(error);
      return 0;
    }
  }
};

// * lockType: 0 -> Unstake, 1 -> Withdraw
export const getDelegatorLock = async (msgSender, dtokenAddress, lockType) => {
  try {
    const provider = new ethers.providers.JsonRpcProvider(RPC_URL);
    const delegationManagerContract = new ethers.Contract(
      DELEGATION_MANAGER_ADDRESS,
      DelegationManagerABI,
      provider
    );
    const lock = await delegationManagerContract.delegatorLocks(
      msgSender,
      dtokenAddress,
      lockType
    );
    console.log(lock);
    return lock;
  } catch (error) {
    console.log("error occured while fetching delegator lock", error);
  }
};

export const getWithdrawInitiationPeriod = async () => {
  try {
    const provider = new ethers.providers.JsonRpcProvider(RPC_URL);
    const delegationManagerContract = new ethers.Contract(
      DELEGATION_MANAGER_ADDRESS,
      DelegationManagerABI,
      provider
    );
    const period = await delegationManagerContract.withdrawInitiationPeriod();
    return period;
  } catch (error) {
    console.log(
      "error occured while fetching withdraw initiation period",
      error
    );
  }
};

export const getUnstakeLock = async (address, validatorDTokenAddress) => {
  try {
    const provider = new ethers.providers.JsonRpcProvider(RPC_URL);
    const delegationManagerContract = new ethers.Contract(
      DELEGATION_MANAGER_ADDRESS,
      DelegationManagerABI,
      provider
    );
    const lock = await delegationManagerContract.delegatorLocks(
      address,
      validatorDTokenAddress,
      0
    );
    return lock;
  } catch (error) {
    console.log("error occured while fetching unstake lock", error);
  }
};

export const getWithdrawLock = async (address, validatorDTokenAddress) => {
  try {
    const provider = new ethers.providers.JsonRpcProvider(RPC_URL);
    const delegationManagerContract = new ethers.Contract(
      DELEGATION_MANAGER_ADDRESS,
      DelegationManagerABI,
      provider
    );
    const lock = await delegationManagerContract.delegatorLocks(
      address,
      validatorDTokenAddress,
      1
    );
    return lock;
  } catch (error) {
    console.log("error occured while fetching unstake lock", error);
  }
};

export const convertTime = (
  epoch,
  dynasty,
  unlockAfter,
  unlockBefore,
  after
) => {
  if (epoch && dynasty) {
    if (after && dynasty < unlockAfter) {
      const completed = epoch % DYNASTY_LENGTH;
      const epochsRemaining = DYNASTY_LENGTH - completed;
      const timeRemaining =
        ((unlockAfter - dynasty) * DYNASTY_LENGTH +
          epochsRemaining -
          DYNASTY_LENGTH) *
        EPOCH_LENGTH;
      let hours = Math.floor(timeRemaining / 3600);
      let minutes = Math.floor((timeRemaining % 3600) / 60);
      return hours + "h " + minutes + "m";
    } else if (!after && dynasty < unlockBefore) {
      const completed = epoch % DYNASTY_LENGTH;
      const epochsRemaining = DYNASTY_LENGTH - completed;
      const timeRemainingAfter =
        ((unlockAfter - dynasty) * DYNASTY_LENGTH +
          epochsRemaining -
          DYNASTY_LENGTH) *
        EPOCH_LENGTH;
      const timeRemaining =
        timeRemainingAfter > 0
          ? ((unlockBefore - dynasty) * DYNASTY_LENGTH +
              epochsRemaining -
              DYNASTY_LENGTH) *
              EPOCH_LENGTH -
            timeRemainingAfter
          : ((unlockBefore - dynasty) * DYNASTY_LENGTH +
              epochsRemaining -
              DYNASTY_LENGTH) *
            EPOCH_LENGTH;
      let hours = Math.floor(timeRemaining / 3600);
      let minutes = Math.floor((timeRemaining % 3600) / 60);
      return hours + "h " + minutes + "m";
    }
  }
  return "0h 0m";
};

export const getETA = (timestamp, unlockAfter, unlockBefore, after) => {
  if (timestamp) {
    if (after) {
      return moment.unix(unlockAfter).from(moment.unix(timestamp));
    } else {
      return moment.unix(unlockBefore).from(moment.unix(timestamp));
    }
  }
  return "0h 0m";
};

export const getTimeFrom = (from, to) => {
  return moment.unix(from).from(moment.unix(to));
};
